import React from 'react';
/**
 * Studio App Entry Point
 */

import { StudioRoot } from './StudioApp/StudioRoot';
export function StudioApp() {
  return <StudioRoot data-id="element-509" />;
}